// extracted by mini-css-extract-plugin
export default {"forgotWrapper":"setyourpassword_forgotWrapper__il3ia"};